import React from "react";
import cs from "classnames";
import styles from "./styles.module.scss";
import { MultiEditIcon, TrashIcon } from "./icons";
import { NewOrderKeywordsToolbarProps } from "./types";

/**
 * Toolbar above the keywords setup table of the Search Terms flow (Figma
 * 1032:6302): app info (icon • store • flag country • optional type slot),
 * the "N keywords selected" counter and the Multi-Set Up / Remove actions.
 * Without `appName` the left side holds only the type slot, for a page that
 * shows the app elsewhere. Pure
 * presentational — icons arrive as slots, disabling rules live in the host
 * (Multi-Set Up needs ≥2 selected, Remove needs ≥1).
 */
export const NewOrderKeywordsToolbar: React.FC<
  NewOrderKeywordsToolbarProps
> = ({
  appName,
  appIcon,
  storeName,
  storeIcon,
  countryCode,
  countryIcon,
  typeSlot,
  selectedCount,
  multiSetUpDisabled = false,
  removeDisabled = false,
  onMultiSetUp,
  onRemove,
  className,
}) => (
  <div
    className={cs(styles.toolbar, { [styles.slotOnly]: !appName }, className)}
  >
    <div className={styles.appInfo}>
      {appName ? (
        <>
          {appIcon && <span className={styles.appIcon}>{appIcon}</span>}
          <span className={styles.appName} title={appName}>
            {appName}
          </span>
          <span className={styles.separator}>•</span>
          {storeIcon && <span className={styles.storeIcon}>{storeIcon}</span>}
          <span>{storeName}</span>
          <span className={styles.separator}>•</span>
          {countryIcon && (
            <span className={styles.flagIcon}>{countryIcon}</span>
          )}
          <span>{countryCode}</span>
          {typeSlot && (
            <>
              <span className={styles.separator}>•</span>
              {typeSlot}
            </>
          )}
        </>
      ) : (
        typeSlot
      )}
    </div>

    <span className={styles.counter}>
      {selectedCount} keyword{selectedCount === 1 ? "" : "s"} selected
    </span>

    <div className={styles.actions}>
      <button
        type="button"
        className={cs(styles.button, styles.multiSetUp)}
        disabled={multiSetUpDisabled}
        onClick={onMultiSetUp}
      >
        <MultiEditIcon className={styles.buttonIcon} />
        Multi-Set Up
      </button>
      <button
        type="button"
        className={cs(styles.button, styles.remove)}
        disabled={removeDisabled}
        onClick={onRemove}
      >
        <TrashIcon className={styles.buttonIcon} />
        Remove
      </button>
    </div>
  </div>
);

export default NewOrderKeywordsToolbar;
